var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28423 2.9511C6.44104 0.794295 9.93791 0.794294 12.0947 2.9511C14.2515 5.10791 14.2515 8.60478 12.0947 10.7616L8.18947 14.6668L4.28423 10.7616C2.12742 8.60478 2.12742 5.10791 4.28423 2.9511ZM8.18947 8.4343C9.06096 8.4343 9.76743 7.72783 9.76743 6.85634C9.76743 5.98486 9.06096 5.27839 8.18947 5.27839C7.31799 5.27839 6.61152 5.98486 6.61152 6.85634C6.61152 7.72783 7.31799 8.4343 8.18947 8.4343Z",
    fill: "#285E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarker);
export default __webpack_public_path__ + "static/media/blue-marker.4f799ab72ae743831d94ee312d5fbcae.svg";
export { ForwardRef as ReactComponent };